module.exports = __webpack_public_path__ + "public/img/waterChart.38e5d335.png";